import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Transaction.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListTranslationPage - Lazy-loaded ListTransactionPage component.
 */
const ListTransactions = Loadable(lazy(() => import("./ListTransactionPage")));

/**
 * Array containing route definitions for the Transaction-related pages.
 * @constant {Object[]} TransactionPageRoutes - Array of Transaction route objects.
 * @property {React.ReactElement} TransactionPageRoutes[].element - The React element to be rendered for the Transaction route.
 */
const TransactionPageRoutes = [
  {
    path: "list",
    element: <ListTransactions />,
  },
];

export default TransactionPageRoutes;
